import api from '../../../../services/api';

export type FormId = string;

export interface FormPayload {
  // Campos do formulário de foodservice
  [key: string]: any;
}

export interface FormRecord {
  id: FormId;
  [key: string]: any;
}

/**
 * IMPORTANTE:
 * Seu backend está montado em app.use('/foodservice-form', foodserviceFormRoutes);
 * Logo, as rotas válidas são:
 *   GET/POST   /foodservice-form
 *   GET/PUT/DELETE /foodservice-form/:id
 *
 * No front estava '/digital/foodservice_form' (substituí por '/foodservice-form').
 */
const basePath = '/foodservice-form';

export async function listForms(restauranteId?: number): Promise<FormRecord[]> {
  try {
    const res = await api.get(basePath, {
      params: restauranteId ? { restaurante_id: restauranteId } : undefined,
    });
    return res.data;
  } catch (err: any) {
    const msg = `Erro ao listar formulários: ${err?.response?.status || ''} ${err?.response?.statusText || ''}`;
    console.error(msg, err?.response?.data || err);
    throw new Error(msg);
  }
}

export async function getForm(id: FormId, restauranteId?: number): Promise<FormRecord> {
  try {
    const res = await api.get(`${basePath}/${id}`, {
      params: restauranteId ? { restaurante_id: restauranteId } : undefined,
    });
    return res.data;
  } catch (err: any) {
    const msg = `Erro ao buscar formulário ${id}: ${err?.response?.status || ''} ${err?.response?.statusText || ''}`;
    console.error(msg, err?.response?.data || err);
    throw new Error(msg);
  }
}

export async function createForm(data: FormPayload, restauranteId?: number): Promise<FormRecord> {
  try {
    const payload = restauranteId ? { ...data, restaurante_id: restauranteId } : data;
    const res = await api.post(basePath, payload);
    return res.data;
  } catch (err: any) {
    const msg = `Erro ao criar formulário: ${err?.response?.status || ''} ${err?.response?.statusText || ''}`;
    console.error(msg, err?.response?.data || err);
    throw new Error(msg);
  }
}

export async function updateForm(id: FormId, data: FormPayload, restauranteId?: number): Promise<FormRecord> {
  try {
    const payload = restauranteId ? { ...data, restaurante_id: restauranteId } : data;
    const res = await api.put(`${basePath}/${id}`, payload);
    return res.data;
  } catch (err: any) {
    const msg = `Erro ao atualizar formulário ${id}: ${err?.response?.status || ''} ${err?.response?.statusText || ''}`;
    console.error(msg, err?.response?.data || err);
    throw new Error(msg);
  }
}

export async function deleteForm(id: FormId, restauranteId?: number): Promise<void> {
  try {
    await api.delete(`${basePath}/${id}`, {
      params: restauranteId ? { restaurante_id: restauranteId } : undefined,
    });
  } catch (err: any) {
    const msg = `Erro ao excluir formulário ${id}: ${err?.response?.status || ''} ${err?.response?.statusText || ''}`;
    console.error(msg, err?.response?.data || err);
    throw new Error(msg);
  }
}

const foodserviceFormApi = {
  listForms,
  getForm,
  createForm,
  updateForm,
  deleteForm,
};

export default foodserviceFormApi;
